import styled from 'styled-components';
import { colors } from '../../css';

export const StyledRichText = styled.div`
  ${({ disabled }) => disabled && `color: ${colors.colorGrey03};`}
  ${({ labelColor }) => labelColor && `color: ${labelColor};`}
  ${({ fontSize = 'inherit' }) => `font-size: ${fontSize};`}
  ${({ lineHeight = 'inherit' }) => `line-height: ${lineHeight};`}
`;
